module.exports = __webpack_public_path__ + "static/media/loginbg.615d74c6.png";